import { axiosInstanceMain } from "../../../../utils/axiosGlobalUtils";
import { ITenant } from "../../../AbmLocalPage/types";

export const archivarPedidos = (idPedido: number, tenant: ITenant) =>
  axiosInstanceMain.post(`${tenant.path}/pedidos/${idPedido}/archivar`);

export const desarchivarPedidos = (idPedido: number, tenant: ITenant) =>
  axiosInstanceMain.post(`${tenant.path}/pedidos/${idPedido}/desarchivar`);
